import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 14, count, showEmpty = true, interactive = false, onChange }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="flex items-center gap-1" data-testid="star-rating">
      <div className="flex items-center">
        {stars.map((s) => {
          const filled = value >= s - 0.25;
          const Comp = interactive ? "button" : "span";
          return (
            <Comp
              key={s}
              type={interactive ? "button" : undefined}
              onClick={interactive ? () => onChange && onChange(s) : undefined}
              data-testid={interactive ? `star-${s}` : undefined}
              className={interactive ? "cursor-pointer transition-transform hover:scale-110" : "inline-flex"}
            >
              <Star
                style={{ width: size, height: size }}
                className={filled ? "fill-[#F59E0B] text-[#F59E0B]" : "text-[#CBD5E1]"}
              />
            </Comp>
          );
        })}
      </div>
      {count != null && count > 0 && (
        <span className="text-xs text-[#94A3B8] ml-0.5">({count})</span>
      )}
    </div>
  );
}
